function Illustration() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="131" height="100" viewBox="0 0 131 100" fill="none">
      <ellipse cx="65.4994" cy="80.3922" rx="51.3158" ry="10.7843" fill="#E5DADE" />
      <g filter="url(#filter0_b_5239_90)">
        <path
          d="M96.0809 80.0879H100.678V18.7055C100.678 16.7725 99.1106 15.2055 97.1776 15.2055H33.8242C31.8912 15.2055 30.3242 16.7725 30.3242 18.7055V72.5879C30.3242 76.73 33.6821 80.0879 37.8242 80.0879H96.0809Z"
          stroke="#8A1538"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <g filter="url(#filter1_b_5239_90)">
        <path
          d="M101.178 80.5879V18.7055C101.178 16.4964 99.3867 14.7055 97.1776 14.7055H33.8242C31.6151 14.7055 29.8242 16.4964 29.8242 18.7055V72.5879C29.8242 77.0062 33.4059 80.5879 37.8242 80.5879H96.0809"
          stroke="#8A1538"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <line x1="29.8242" y1="23.0298" x2="101.178" y2="23.0298" stroke="#8A1538" />
      <line x1="66.4883" y1="23.5298" x2="66.4883" y2="80.3925" stroke="#8A1538" strokeDasharray="2 2" />
      <line x1="29.8242" y1="40.6763" x2="101.178" y2="40.6763" stroke="#8A1538" strokeDasharray="2 2" />
      <line x1="29.8242" y1="60.2842" x2="65.9896" y2="60.2842" stroke="#8A1538" strokeDasharray="2 2" />
      <g filter="url(#filter2_b_5239_90)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M85.3903 29.3842C83.3888 26.987 82.2998 23.9554 82.3171 20.8286C82.3462 14.6435 86.6114 9.29011 92.6196 7.89745C98.6279 6.5048 104.802 9.43843 107.534 14.9836C110.266 20.5288 108.838 27.2302 104.085 31.171C99.3319 35.1117 92.5013 35.2575 87.5855 31.5231"
          fill="white"
        />
        <path
          d="M85.3903 29.3842C83.3888 26.987 82.2998 23.9554 82.3171 20.8286C82.3462 14.6435 86.6114 9.29011 92.6196 7.89745C98.6279 6.5048 104.802 9.43843 107.534 14.9836C110.266 20.5288 108.838 27.2302 104.085 31.171C99.3319 35.1117 92.5013 35.2575 87.5855 31.5231"
          stroke="#8A1538"
          strokeLinecap="round"
        />
      </g>
      <path d="M101.005 15.5181L90.4215 26.6394" stroke="#8A1538" strokeLinecap="round" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M100.992 26.8989C101.187 27.0945 101.503 27.0949 101.699 26.9C101.895 26.705 101.895 26.3884 101.7 26.1929L100.308 24.7967L99.602 25.5048L100.992 26.8989ZM98.6743 24.5744L99.3804 23.8663L90.7042 15.1641C90.5092 14.9685 90.1926 14.968 89.997 15.163C89.8015 15.358 89.801 15.6746 89.996 15.8701L98.6743 24.5744Z"
        fill="#8A1538"
      />
      <path
        d="M37.1433 19.1171C37.1433 19.6545 36.7093 20.0877 36.1771 20.0877C35.6449 20.0877 35.2109 19.6545 35.2109 19.1171C35.2109 18.5796 35.6449 18.1465 36.1771 18.1465C36.7093 18.1465 37.1433 18.5796 37.1433 19.1171Z"
        fill="#8A1538"
        stroke="#8A1538"
      />
      <path
        d="M41.0534 19.1171C41.0534 19.6545 40.6194 20.0877 40.0873 20.0877C39.5551 20.0877 39.1211 19.6545 39.1211 19.1171C39.1211 18.5796 39.5551 18.1465 40.0873 18.1465C40.6194 18.1465 41.0534 18.5796 41.0534 19.1171Z"
        fill="#8A1538"
        stroke="#8A1538"
      />
      <path
        d="M44.9616 19.1171C44.9616 19.6545 44.5276 20.0877 43.9955 20.0877C43.4633 20.0877 43.0293 19.6545 43.0293 19.1171C43.0293 18.5796 43.4633 18.1465 43.9955 18.1465C44.5276 18.1465 44.9616 18.5796 44.9616 19.1171Z"
        fill="#8A1538"
        stroke="#8A1538"
      />
      <defs>
        <filter
          id="filter0_b_5239_90"
          x="25.8242"
          y="10.7056"
          width="79.3533"
          height="73.8823"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_5239_90" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_5239_90" result="shape" />
        </filter>
        <filter
          id="filter1_b_5239_90"
          x="25.3242"
          y="10.2056"
          width="80.3533"
          height="74.8823"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_5239_90" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_5239_90" result="shape" />
        </filter>
        <filter
          id="filter2_b_5239_90"
          x="77.8169"
          y="3.05371"
          width="35.5938"
          height="35.6743"
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix" />
          <feGaussianBlur in="BackgroundImageFix" stdDeviation="2" />
          <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_5239_90" />
          <feBlend mode="normal" in="SourceGraphic" in2="effect1_backgroundBlur_5239_90" result="shape" />
        </filter>
      </defs>
    </svg>
  );
}

export default Illustration;
